var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { Rate as ArcoRate, Typography } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import './style/rate.less';
var RateRender = function (props, ref) {
    var afterRateDescription = props.afterRateDescription, _a = props.descriptionPosition, descriptionPosition = _a === void 0 ? 'right' : _a, _b = props.descriptionWidth, descriptionWidth = _b === void 0 ? 205 : _b, afterRateTitle = props.afterRateTitle, description = props.description, tooltipProps = props.tooltipProps, className = props.className, title = props.title, style = props.style, _c = props.ellipsisLineCount, ellipsisLineCount = _c === void 0 ? 1 : _c, _d = props.centerDisplay, centerDisplay = _d === void 0 ? false : _d, onChange = props.onChange, defaultValue = props.defaultValue, rest = __rest(props, ["afterRateDescription", "descriptionPosition", "descriptionWidth", "afterRateTitle", "description", "tooltipProps", "className", "title", "style", "ellipsisLineCount", "centerDisplay", "onChange", "defaultValue"]);
    var readonly = props.readonly || false;
    var value = (props === null || props === void 0 ? void 0 : props.value) || 0;
    var _e = useState(0), level = _e[0], setLevel = _e[1];
    var _f = useState(title), displayTitle = _f[0], setDisplayTitle = _f[1];
    var _g = useState(description), displayDesc = _g[0], setDisplayDesc = _g[1];
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-rate");
    var classnames = cx(prefixCls, className, centerDisplay ? "".concat(globalPrefixCls, "-rate-center") : '');
    var descriptionClass = cx(centerDisplay
        ? "".concat(prefixCls, "-description-content-center")
        : "".concat(prefixCls, "-description-content-").concat(descriptionPosition));
    var TitleNode = useMemo(function () {
        if (typeof title === 'string') {
            return React.createElement("div", { className: "".concat(prefixCls, "-title-content") }, displayTitle);
        }
        return displayTitle;
    }, [displayTitle, title]);
    var afterDisplay = function (v) {
        afterRateTitle && setDisplayTitle(afterRateTitle);
        afterRateDescription &&
            setDisplayDesc(v <= afterRateDescription.length ? afterRateDescription[Math.ceil(v - 1)] : '');
    };
    useEffect(function () {
        if (readonly) {
            afterDisplay(defaultValue || value);
        }
        if (!readonly && level) {
            afterDisplay(level);
        }
        if (!readonly && !level) {
            setDisplayTitle(title);
            setDisplayDesc(description);
        }
    }, [level, value, defaultValue, readonly, title, description]);
    var handleChange = function (value) {
        onChange && onChange(value);
        (afterRateTitle || afterRateDescription) && setLevel(value);
    };
    return (React.createElement("div", { className: classnames, style: style, "data-tid": "m4b_rate" },
        title && TitleNode,
        React.createElement("div", { className: descriptionClass },
            React.createElement(ArcoRate, __assign({}, rest, { ref: ref, onChange: handleChange, defaultValue: defaultValue })),
            (description || afterRateDescription) && (React.createElement("div", { className: "".concat(prefixCls, "-typography"), style: { width: "".concat(descriptionWidth, "px") } },
                React.createElement(Typography.Paragraph, { ellipsis: {
                        rows: ellipsisLineCount,
                        showTooltip: {
                            type: 'tooltip',
                            props: tooltipProps || { content: displayDesc },
                        },
                    } }, displayDesc))))));
};
var Rate = forwardRef(RateRender);
Rate.displayName = 'Rate';
export default Rate;
